<header>
  <div class="bg-blue-base" style="height: 50px;">
    <div class="gov-container width-container mx-auto flex
     justify-content-between pr-4 align-items-center">
      <a href="https://www.gov.co" rel="noopener" role="link"
         aria-label="Logo Gobierno de Colombia. Te llevará al inicio">
        <img src="assets/img/svg/logo-gov.svg" alt="logo gov.co"
             height="27.23" draggable="false" width="135.15"/>
      </a>

      <a href="https://www.gov.co"
         aria-label="Envíe al sitio web oficial del Gobierno de Colombia"
         rel="noopener" target="_blank"
         class="text-white no-underline text-xl animated-text "> Ir a GOV.CO</a>
    </div>
  </div>
  <div class="gov-container width-container mx-2 lg:mx-auto ">
    <div class="flex-column flex lg:flex-row lg:justify-content-between">
      <div class=" flex justify-content-between  lg:justify-content-start lg:w-fit">
        <a role="link" class="ml-2 lg:ml-0">
          <picture>
            <source media="(width < 800px)" srcset="assets/img/icons-principal/logo-sede-electronica-responsive.png">
            <source media="(width >= 800px)" srcset="assets/img/icons-principal/logo-sede-electronica.svg">
            <img class=" logo-main" src="assets/img/icons-principal/logo-sede-electronica.svg"
                 draggable="false" alt="Portal de Tramites Gobernacion del Magdalena"/>
          </picture>
        </a>
        <div class="flex lg:hidden justify-content-end align-items-center mr-2">
          <a (click)="op.toggle($event)" class="text-blue-general no-underline flex align-items-center cursor-pointer"
             role="menu" aria-label="Abrir menú de navegación del portal de trámites">
            <span class="font-16 animated-text">Menú</span>
            <img ngSrc="assets/img/svg/menu.svg" alt="icono menú"
                 height="26" width="35" draggable="false"/>
          </a>
        </div>
      </div>

      <div class="flex flex-column lg:w-fit">
        <a class="text-blue-general no-underline text-right mr-3 hidden lg:block "
           routerLink="/public/consulta">
          <span>{{'components.app-sede-electronica.iniciar-sesion-portal' | translate}}</span>
          <i class="pi ml-2 pi-sign-in"></i>
        </a>
        <div class=" bg-white border-2 border-gray-300 container-input-rounded content-border
         active-border-gradient mt-4 p-0" *ngIf="!hideSearch">
          <div class="input-text  inline-flex md:border-none w-full">
            <input pInputText type="text" class="input-text-gray w-full font-16 font-normal"
                   [(ngModel)]="nombreTramite"  (keydown.enter)="search()"
                   [placeholder]="'components.app-sede-electronica.que-tramite-quieres-hacer' | translate"/>
          </div>
          <div class="inline-flex align-items-center  ">
            <button pButton class="search p-button-icon-only btn-blue-general"
                    (click)="search()"   type="button">
              <i class="pi pi-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mx-2 lg:mx-auto lg:block hidden" style="background: #fafafa;" >
    <div class="width-container mx-auto">
      <p-menubar [model]="menuItems"  styleClass="border-none  "/>
    </div>
  </div>
</header>

<p-overlayPanel #op>
  <ng-template pTemplate="content">
    <div style="width:270px;">
      <app-navbar-gov-co [menuItems]="menuItems"/>
    </div>
  </ng-template>
</p-overlayPanel>
